import { render, staticRenderFns } from "./PreviewAssessment.vue?vue&type=template&id=6072f671"
import script from "./PreviewAssessment.vue?vue&type=script&lang=js"
export * from "./PreviewAssessment.vue?vue&type=script&lang=js"
import style0 from "./PreviewAssessment.vue?vue&type=style&index=0&id=6072f671&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports